import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Button } from '@hotjar/hotsauce';
import { useHelpHotjarUrl } from '@hotjar/translations';
import { Action, Container, Content, Image, ErrorTitle as Title, Subtitle } from './common';
import CheckTrackingImage from '../../icons/check-tracking-code.svg';

const StyledContent = styled(Content)`
  max-width: 320px;
`;

export const NoDataCheckTrackingError = (): JSX.Element => {
  const { t } = useTranslation();
  const helpHotjarUrl = useHelpHotjarUrl();

  return (
    <Container>
      <StyledContent>
        <Image alt="Title" src={CheckTrackingImage} />
        <Title as="p" textType="subtitle1">
          {t('heatmaps:error-states.check-tracking-code.title')}
        </Title>
        <Subtitle as="p" textType="caption" textColor="text_light">
          {t('heatmaps:error-states.check-tracking-code.subtitle')}
        </Subtitle>
        <Action hasExtraPadding>
          <Button
            as="a"
            icon="open_new_window"
            kind="secondary"
            isExternal
            href={`${helpHotjarUrl}/articles/360016303294-How-to-Check-That-Hotjar-Is-Working`}
          >
            {t('heatmaps:error-states.check-tracking-code.action-verify')}
          </Button>
        </Action>
      </StyledContent>
    </Container>
  );
};
